import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { App } from "./App.js"
// Solya design system: the `--ds-*` CSS custom properties (single source of truth).
// Must load BEFORE the console's token bridge, which aliases `--sol-*` onto them.
import "@solya/design-tokens/tokens.css"
import "./styles/tokens.css"
import "./ui/ui.css"

const root = document.getElementById("root")
if (!root) throw new Error("#root not found")

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
)
